module.exports = __webpack_public_path__ + "img/bsi-light.3d079dd1.png";